import React from "react";
import { Card, Button, Icon, Transition } from "semantic-ui-react";
import PropTypes from "prop-types";
import useWindowSize from "../../utils/useWindowSize";
import { useTranslation } from "react-i18next";

/**
 * Card di una offerta su lezione privata ("ListiniOfferta"): non ha un'immagine né un titolo
 * proprio (Name è il codice della stagionalità, uguale per tutte le righe della stessa
 * stagionalità), quindi la card è composta interamente dai suoi dati, come in PortalHybrid.
 *
 * Niente periodo di validità in card, come nel nuovo portale: la card compare solo quando è già
 * filtrata sulle preferenze correnti, quindi ripetere le date qui sarebbe solo rumore.
 */
function SchedaOffertaCard({
  t,
  offerta,
  valuta,
  isVisible,
  onSelect,
  isApplied,
}) {
  const windowSize = useWindowSize();

  return (
    <Transition visible={isVisible} animation="swing up" duration={500}>
      {/* Lo stato "selezionato" rispecchia appliedOfferKey del nuovo portale: la card
          dell'offerta la cui fascia è stata applicata alla timeline si distingue dalle altre.
          Niente colore hardcoded: il "raised" e la classe "selected" sono l'unico aggancio
          disponibile in questa app (non esiste una CSS custom property né una classe già
          tematizzata per il colore primario al di fuori di ".ui.primary.button"). */}
      <Card
        className={
          isApplied ? "schedaCorsoCard selected" : "schedaCorsoCard"
        }
        raised={isApplied}
        style={windowSize.width < 600 ? { width: "100%" } : { width: "31%" }}
      >
        <Card.Content style={{ border: "0" }}>
          <Card.Header as="h3" className="skiwork-card-header">
            {offerta.startTime} - {offerta.endTime}
            {offerta.allDay && (
              <span className="offerta-giornata-intera">
                {t("giornata_intera")}
              </span>
            )}
          </Card.Header>
          <Card.Meta className="skiwork-card-subheader">
            {t("numero_persone_count", { count: offerta.numberOfPeople })}
          </Card.Meta>
        </Card.Content>
        <Card.Content style={{ border: "0" }} textAlign="center">
          <strong>
            {valuta} {offerta.totalPrice.toFixed(2)}
          </strong>
        </Card.Content>
        <Card.Content style={{ border: "0" }} textAlign="center">
          <Button
            primary
            basic={isApplied}
            onClick={() => onSelect(offerta)}
            size="big"
          >
            <Icon name="cart"></Icon>
            {isApplied ? t("selezionato") : t("scegli")}
          </Button>
        </Card.Content>
      </Card>
    </Transition>
  );
}

SchedaOffertaCard.propTypes = {
  t: PropTypes.func.isRequired,
  offerta: PropTypes.object.isRequired,
  valuta: PropTypes.string,
  isVisible: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  isApplied: PropTypes.bool,
};

export default SchedaOffertaCard;
